export { default } from "./TextInfos";
